import { Container, styled } from '@mui/material'

export const StyledAppContainer = styled('div')({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  overflowX: 'hidden'
})

export const StyledDefaultContainer = styled(Container)({
  ['@media (min-width: 1200px)']: {
    maxWidth: '1420px'
  },
  ['@media (max-width: 1199px)']: {
    maxWidth: '1125px',
    padding: '0 80px'
  },
  ['@media (max-width: 1024px)']: {
    padding: '0 10px'
  }
})
